import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
// import socket from "../../services/socket";
import { Main } from "./style";
import axios from "axios";
import { webURL } from "../../services/API";

export function Chatbot() {
   const [items, setItems] = React.useState<{ isFromBot: boolean, message: string }[]>([]);
   const [messageValue, setMessageValue] = React.useState('');
   const [isLoading, setIsLoading] = React.useState(false);
   const [searchParams] = useSearchParams();
   const textareaRef = React.useRef<HTMLTextAreaElement>(null);
   const messagesRef = React.useRef<HTMLDivElement>(null);
   const navigate = useNavigate();

   // ---
   React.useEffect(() => {
      if (window.self === window.top) {
         navigate('/');
      } else {
         (async function() {
            const data = (await axios.get(`${webURL}/user/websiteChetbotHistory?projectId=${searchParams.get('projectId')}`)).data;  
            setItems(data);
         })();
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);
   // ---
   React.useEffect(() => {
      if (items.length && messagesRef.current) messagesRef.current.scrollTo(0, messagesRef.current.scrollHeight);
   }, [items.length]);

   // auto height with textarea
   React.useLayoutEffect(() => {
      const textarea = textareaRef.current; 

      if (textareaRef.current) {
         if (messageValue) { // @ts-ignore
            textarea.style.height = 'auto'; // @ts-ignore
            textarea.style.height = `${textarea.scrollHeight}px`;
            if (messagesRef.current) messagesRef.current.scrollTo(0, messagesRef.current.scrollHeight);
         } else {
            textareaRef.current.removeAttribute('style');
         }
      }
   }, [messageValue]);

   // ---
   const handleSendMessage = async () => {
      // user
      setItems(items => [...items, { isFromBot: false, message: messageValue }]);
      setIsLoading(true);
      setMessageValue('');

      // bot
      const data = (await axios.post(`${webURL}/user/chetbot`, {
         projectId: searchParams.get('projectId'), blockId: searchParams.get('blockId'), blockInx: searchParams.get('blockInx'), message: messageValue
      })).data;
      console.log(data);
      setItems(items => [...items, ...data]);
      setIsLoading(false);
   }

   return (
      <Main>
         <div className="title">
            <h3>Chatbot AI</h3>
            <FontAwesomeIcon icon={ faCircleQuestion } onClick={ _=> window.open('https://dragify.ai/', '_blank') } />
         </div>
         <div ref={ messagesRef } className="scroll">{
            items.length ? items.map((item, index) => (
               <div key={ index.toString() } className="item">
                  <img src={ item.isFromBot ? 'images/chatbot.png' : 'images/default_avatar.webp' } alt="avatar" />
                  <pre>
                     <span>{ item.isFromBot ? 'Bot' : 'Guest' }</span>
                     <span>{ item.message }</span>
                  </pre>
               </div>
            )) : <div className="empty">How can we help you?</div>
         }</div>
         <div className="action">
            <textarea ref={ textareaRef } value={ messageValue } placeholder="Your message..." onChange={ e => setMessageValue(e.target.value) }></textarea>
            <button className={ isLoading ? 'loading' : '' } disabled={ !messageValue } onClick={ handleSendMessage }>
               { isLoading ? <AiOutlineLoading3Quarters /> : <FontAwesomeIcon icon={ faPaperPlane } /> }
            </button>
         </div>
      </Main>
   );
}